export var shouldNameBeTruncated = function (_a) {
    var scrollWidth = _a.scrollWidth, clientWidth = _a.clientWidth;
    return scrollWidth > clientWidth;
};
